import { useState } from 'react';
import { DeliveryService } from '../support/services/api';

export default function useDeliveriesValues(spaceId) {
  const [calculating, setCalculating] = useState(false);
  const [error, setError] = useState();
  const [values, setValues] = useState();
  const [oneAddressValues, setOneAddressValues] = useState();
  const getDeliveriesValues = async (addresses) => {
    setCalculating(true);
    if (addresses.length === 0) return;
    const addrDistAndVal = await DeliveryService().getDistancesAndValues(spaceId, addresses);
    setValues(addrDistAndVal);
    setCalculating(false);
  };

  const getOneAddressDeliveryValues = async (address) => {
    if (!address.number || !address.street) return;
    setCalculating(true);
    try {
      const addrDistAndVal = await DeliveryService(true).getDistancesAndValues(spaceId, [address]);
      if (addrDistAndVal[0]) setOneAddressValues({ distance: addrDistAndVal[0].distance, cost: addrDistAndVal[0].cost });
    } catch (err) {
      setError(err.msg);
    }
    setCalculating(false);
  };

  const resetOneAddressValues = () => setOneAddressValues(null);

  return ({
    sharedStates: {
      error,
      values,
      oneAddressValues,
    },
    commands: {
      getDeliveriesValues,
      getOneAddressDeliveryValues,
      resetOneAddressValues,
    },
    metaStates: {
      calculating,
    },
  });
}
